import jsPDF from "jspdf";
import "jspdf-autotable";
import { format } from "date-fns";
import sflLogo from "./sfl_logo.png";
import { font } from "./Inter_24pt-Regular-normal";

// Define the PdfGenerator component
const PdfGenerator = async ({ pdfHeaderData, pdfTableData }) => {
  // Create a new jsPDF instance
  const pdf = new jsPDF();

  pdf.addFileToVFS("Inter_24pt-Regular-normal.ttf", font);
  pdf.addFont("Inter_24pt-Regular-normal.ttf", "Inter_24pt-Regular", "normal");
  pdf.setFont("Inter_24pt-Regular");
  // Set document properties
  pdf.setProperties({
    title: "Certificate Of Completion",
  });

  pdf.setTextColor(67, 22, 70);

  // Add images and text to the PDF
  const callImage = sflLogo;
  const imageUrl = sflLogo;
  pdf.addImage(imageUrl, "JPEG", 10, 8, 40, 12);
  pdf.setFontSize(10);
  pdf.setFont("custom", "bold");
  pdf.text("CERTIFICATE OF COMPLETION", 150, 12);

  /** Draw rectangle */
  pdf.setFillColor(226, 232, 240);
  pdf.roundedRect(183, 13, 20, 5, 1, 1, "F");

  pdf.setFont("custom", "normal");
  pdf.text(pdfHeaderData.status, 187, 16.5);

  // Line width in units (you can adjust this)
  pdf.setLineWidth(0.1);

  // Line color (RGB)
  pdf.setDrawColor("#E2E8F0");

  /** Draw rectangle */
  pdf.setFillColor(226, 232, 240);
  pdf.roundedRect(9, 32, 98, 47, 1.5, 1.5, "F");

  /** Left column of header */
  /** Left column of header */
  if (pdfHeaderData.shareholdersEnvelopeId) {
    pdf.setFont("custom", "bold");
    pdf.text("Directors Envelope ID     ", 14, 40);
    pdf.setFont("custom", "normal");
    pdf.text(pdfHeaderData.directorsEnvelopeId, 14, 44.5);

    pdf.setFont("custom", "bold");
    pdf.text("Shareholders Envelope ID     ", 14, 50);
    pdf.setFont("custom", "normal");
    pdf.text(pdfHeaderData.shareholdersEnvelopeId, 14, 54.5);
  } else {
    pdf.setFont("custom", "bold");
    pdf.text("Envelope ID     ", 14, 50);
    pdf.setFont("custom", "normal");
    pdf.text(pdfHeaderData.envelopeId, 14, 54.5);
  }

  pdf.setFont("custom", "bold");
  pdf.text("Company ID     ", 14, 60);
  pdf.setFont("custom", "normal");
  pdf.text(pdfHeaderData.companyId, 14, 64.5);

  pdf.setFont("custom", "bold");
  pdf.text("Envelope Originator", 14, 70);
  pdf.setFont("custom", "normal");
  pdf.text(pdfHeaderData.envelopeOriginator, 14, 74.5);

  pdf.line(0, 86.5, 300, 86.5);

  /** Right column of header */
  pdf.setFont("custom", "bold");
  pdf.text("Date Format   ", 70, 40);
  pdf.setFont("custom", "normal");
  pdf.text("dd/mm/yyyy", 70, 44.5);

  pdf.setFont("custom", "bold");
  pdf.text("Date Created    ", 70, 50);
  pdf.setFont("custom", "normal");
  pdf.text(pdfHeaderData.dateCreated, 70, 54.5);

  pdf.setFont("custom", "bold");
  pdf.text("IP Address    ", 70, 60);
  pdf.setFont("custom", "normal");
  pdf.text(pdfHeaderData.ipAddress, 70, 64.5);

  pdf.setFont("custom", "bold");
  pdf.text("Signatures   ", 70, 70);
  pdf.setFont("custom", "normal");
  pdf.text(pdfHeaderData.signatures.toString(), 70, 74.5);

  // Generate AutoTable for item details
  const itemDetailsRows = pdfTableData?.map((item, index) => [
    `${(index + 1).toString()}`,
    item.userDetails,
    item.email,
    item.events,
    item.status,
  ]);
  const itemDetailsHeaders = ["Sn", "Details", "Email", "Events", "Status"];
  const columnWidths = [12, 40, 55, 55, 25]; // Adjust column widths as needed
  // Define table styles
  const headerStyles = {
    fillColor: [226, 232, 240],
    textColor: [67, 22, 70],
    fontFamily: "custom",
    fontStyle: "bold",
  };

  pdf.setFont("custom", "normal");
  let itemDetailsYStart = 92;

  pdf.autoTable({
    head: [itemDetailsHeaders],
    body: itemDetailsRows,
    startY: itemDetailsYStart, // Adjust the Y position as needed
    headStyles: {
      fillColor: headerStyles.fillColor,
      textColor: headerStyles.textColor,
      fontStyle: headerStyles.fontStyle,
      fontSize: 10, // Adjust the font size as needed
      font: "custom", // Set the font family
      halign: "left",
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0] }, // Adjust column widths as needed
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
      4: { cellWidth: columnWidths[4] },
    },

    bodyStyles: {
      fontSize: 10, // Adjust the font size for the body
      font: "custom", // Set the font family for the body
      cellPadding: { top: 1, right: 5, bottom: 1, left: 2 }, // Adjust cell padding
      textColor: [67, 22, 70], // Set text color for the body
      rowPageBreak: "avoid", // Avoid row page breaks
      useCss: true,
    },
    styles: {
      table: {
        borderCollapse: "collapse",
      },
      tr: {
        borderBottom: "1pt solid black",
      },
    },
    margin: { top: 10, left: 13 },
  });

  // Add summary and page numbers
  const summaryYStart = pdf.internal.pageSize.getHeight() - 50;

  const totalPages = pdf.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    pdf.line(10, 283, 200, 283);
    pdf.setPage(i);
    pdf.setFont("custom");
    pdf.text(
      `Page ${i} of ${totalPages}`,
      185,
      pdf.internal.pageSize.getHeight() - 5
    );
  }

  // Save the PDF
  // pdf.save(`RFQ.pdf`);

  // pdf open in a new tab
  const pdfDataUri = pdf.output("datauristring");
  const newTab = window.open(window.origin, "theFrame");
  newTab?.document.write(
    `<iframe width='100%' height='100%' src='${pdfDataUri}'></iframe>`
  );
};

export default PdfGenerator;
